import InterestInventoryResults from "./InterestInventoryResults";

export default InterestInventoryResults;
